import request from "@/common/request"
import { AnalyticsData } from "@/models/AnalyticsData"

const basePath = '/analytics'

export const find = (identificador: string, lojas: string[], isVendedor?: boolean): Promise<AnalyticsData> =>
	request.get(`${basePath}/dashboard-url/${identificador}?lojas=${lojas.join(',')}&isVendedor=${isVendedor ? isVendedor : false}`)